import { useCallback, useEffect, useState } from "react";
import {
  getAnalytics,
  getAnalyticsByDate,
  getPercentageAnalytics,
} from "../../../api/business";
import HomeGraphCard from "../../../components/common/homeGraphCard";
import HomeMessageCard from "../../../components/common/homeMessageCard";
import HomeOrderCard from "../../../components/common/homeOrderCard";
import { Link } from "react-router-dom";
import { fetchOrdersList } from "../../../store/slices/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import NotificationsNav from "../../../components/common/notificationNav";

const Home = () => {
  const [data, setData] = useState();
  const [filterData, setFilterData] = useState();
  const [percent, setPercent] = useState();
  const [filter, setFilter] = useState("weekly");
  const dispatch = useDispatch();
  const orders = useSelector((state) => state?.order?.response);
  const notification = useSelector((state) => state?.user);
  const getAnalyticsData = async () => {
    // const res = await getAnalytics();
    const businessId = localStorage.getItem("businessId")
    const userId = localStorage.getItem("userId")
    const res = await getAnalytics(businessId, userId);
    setData(res);
    return res;
  };

  const getPercentage = async (filter) => {
    const res = await getPercentageAnalytics(filter);
    setPercent(res);
  };
  const fetchData = useCallback(async () => {
    const payload = {
      orderStatus: ["COMPLETED"],
    };
    dispatch(fetchOrdersList(payload));
  });
  const getAnalyticsByFilter = async (filter) => {
    const res = await getAnalyticsByDate(filter);
    setFilterData(res);
  };

  useEffect(() => {
    getAnalyticsData();
    fetchData();
  }, []);

  useEffect(() => {
    getPercentage(filter);
    getAnalyticsByFilter(filter);
  }, [filter]);

  return (
    <>
      <div className="2xl:w-90%">
        <div className=" grid xl:grid-cols-4 sm:grid-cols-2 ">
          <Link to={"/main/orders"} className="m-2">
            <HomeOrderCard data={data} percentage={percent} filter={filter} />
          </Link>
          <Link to={"/main/orders/appointments"} className="m-2">
            <HomeOrderCard
              appointment={true}
              data={data}
              filter={filter}
              percentage={percent}
            />
          </Link>
          <div className="m-2">
            <HomeMessageCard />
          </div>
          <Link to={"/main/orders/history"} className="m-2">
            <HomeMessageCard order={true} data={orders?.items} />
          </Link>
        </div>
        <div>
          <div>
            {" "}
            <p className="text-lg font-medium ml-2">Analytics</p>
          </div>
          <div className="m-2 shadow-md">
            <div className=" grid justify-center xl:grid-cols-5 md:grid-cols-3 grid-cols-2 border border-solid border-inputFieldGrey rounded">
              <div className="ml-2">
                <p className="text-primaryPurple text-base font-medium">
                  Gross Volume
                </p>
                <p className="text-xl font-light mt-0 truncate">
                  $
                  {parseFloat(
                    data?.totalGrossVolume?.toFixed(2) ?? 0
                  ).toLocaleString()}
                </p>
              </div>
              <div>
                <p className="text-primaryPurple text-base font-medium">
                  Sales
                </p>
                <p className="text-xl font-light  mt-0">
                  {parseFloat(data?.totalSales ?? 0).toLocaleString()}
                </p>
              </div>
              <div className="ml-2 md:ml-0">
                <p className="text-primaryPurple text-base font-medium">
                  Customers
                </p>
                <p className="text-xl font-light  mt-0">
                  {parseFloat(
                    data?.totalCustomers?.length ?? 0
                  ).toLocaleString()}
                </p>
              </div>
              <div className="ml-2 xl:ml-0">
                <p className="text-primaryPurple text-base font-medium">
                  Appointments
                </p>
                <p className="text-xl font-light  mt-0">
                  {parseFloat(data?.totalAppointments ?? 0).toLocaleString()}
                </p>
              </div>
              <div className="ml-2 md:ml-0">
                <p className="text-primaryPurple text-base font-medium truncate">
                  Payouts
                </p>
                <p className="text-xl font-light  mt-0">
                  $
                  {parseFloat(
                    data?.totalPayouts?.toFixed(2) ?? 0
                  ).toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </div>
        <HomeGraphCard
          setFilter={setFilter}
          graphData={filterData}
          week={filter}
        />
      </div>

      {notification?.notification?.isNew && (
        <NotificationsNav
          key={notification?.notification?.title}
          data={notification}
        />
      )}
    </>
  );
};
export default Home;
